import { render } from "./ReattachRequisiteModal.vue?vue&type=template&id=6550def0&ts=true"
import script from "./ReattachRequisiteModal.vue?vue&type=script&lang=ts"
export * from "./ReattachRequisiteModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__